import React from 'react';
import MuiAlert, { AlertColor } from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { ActionButton } from '..';
import { muiColorType } from '../../hooks';

export type muiButtonVariantTypes = 'text' | 'contained' | 'outlined' | undefined;

interface OptionProps {
    message?: string;
    color?: muiColorType;
    variant?: muiButtonVariantTypes;
    Icon?: React.ReactNode;
}

export interface AlertProps {
    closeHandler: () => void;
    message: any;
    open: boolean;
    label?: string;
    severity?: AlertColor | undefined;
    variant?: 'snackbar' | 'dialog';
    disableCancel?: boolean;
    denyOptions?: OptionProps;
    acceptOptions?: OptionProps;
    anchorOrigin?: SnackbarOrigin | undefined;
    denyHandler?: () => void;
    acceptHandler?: () => void;
}

export const Alert: React.FC<AlertProps> = React.memo(
    ({
        closeHandler,
        message,
        open,
        label,
        severity,
        variant,
        disableCancel,
        denyOptions,
        acceptOptions,
        anchorOrigin,
        denyHandler,
        acceptHandler
    }) =>
        variant === 'dialog' ? (
            <Dialog
                open={open}
                onClose={closeHandler}
                aria-labelledby={`${label}-alert-dialog-title`}
                aria-describedby={`${label}-alert-dialog-description`}
            >
                <DialogTitle>
                    {typeof message === 'string' ? message : message()}
                </DialogTitle>
                <DialogActions>
                    {!disableCancel && (
                        <ActionButton
                            title={
                                denyOptions?.message
                                    ? denyOptions?.message
                                    : 'Cancel'
                            }
                            onClick={denyHandler ? denyHandler : closeHandler}
                            color={
                                denyOptions?.color ? denyOptions?.color : 'inherit'
                            }
                            variant={denyOptions?.variant}
                        />
                    )}
                    <ActionButton
                        title={
                            acceptOptions?.message
                                ? acceptOptions?.message
                                : 'Confirm'
                        }
                        onClick={acceptHandler ? acceptHandler : closeHandler}
                        color={
                            acceptOptions?.color ? acceptOptions?.color : 'primary'
                        }
                        variant={acceptOptions?.variant}
                    />
                </DialogActions>
            </Dialog>
        ) : (
            <Snackbar
                anchorOrigin={anchorOrigin}
                open={open}
                autoHideDuration={6000}
                onClose={closeHandler}
                action={
                    <IconButton
                        size='small'
                        aria-label='close'
                        color='inherit'
                        onClick={closeHandler}
                    >
                        <CloseIcon fontSize='small' />
                    </IconButton>
                }
                aria-labelledby={`${label}-alert-dialog-title`}
                aria-describedby={`${label}-alert-dialog-description`}
            >
                <MuiAlert
                    severity={severity ? severity : 'success'}
                    variant='filled'
                    sx={{ width: '100%' }}
                    onClose={closeHandler}
                >
                    {typeof message === 'string' ? message : message()}
                </MuiAlert>
            </Snackbar>
        )
);
